module.exports = __webpack_public_path__ + "assets/img/NPC029.36ce20b3.png";